module.exports = __webpack_public_path__ + "static/media/athlinks-services.0e089f28.svg";